import React from 'react';
import { Save, Mail } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { toast } from 'sonner';

export const EmailSettingsTab = () => {
  return (
    <Card className="rounded-xl border-slate-200 shadow-sm">
      <CardHeader>
        <CardTitle className="text-lg flex items-center gap-2">
          <Mail className="h-5 w-5" />
          Email Settings
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <div>
          <h3 className="font-semibold text-slate-900 mb-3">SMTP Configuration</h3>
          <div className="space-y-4">
            <div>
              <Label>SMTP Provider</Label>
              <Input placeholder="e.g., SendGrid, Mailgun, AWS SES" className="mt-2" />
            </div>
            <div>
              <Label>SMTP Host</Label>
              <Input placeholder="smtp.example.com" className="mt-2" />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>SMTP Port</Label>
                <Input placeholder="587" type="number" className="mt-2" />
              </div>
              <div>
                <Label>Encryption</Label>
                <select className="mt-2 flex h-10 w-full rounded-md border border-slate-200 bg-white px-3 py-2 text-sm">
                  <option>TLS</option>
                  <option>SSL</option>
                  <option>None</option>
                </select>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>SMTP Username</Label>
                <Input placeholder="your-username" className="mt-2" />
              </div>
              <div>
                <Label>SMTP Password</Label>
                <Input type="password" placeholder="••••••••" className="mt-2" />
              </div>
            </div>
          </div>
        </div>
        
        <div className="pt-4 border-t">
          <h3 className="font-semibold text-slate-900 mb-3">Email Addresses</h3>
          <div className="space-y-4">
            <div>
              <Label>From Email</Label>
              <Input defaultValue="noreply@propfirmhouse.com" className="mt-2" />
              <p className="text-xs text-slate-500 mt-1">Email address shown as sender</p>
            </div>
            <div>
              <Label>From Name</Label>
              <Input defaultValue="PropFirmHouse" className="mt-2" />
            </div>
            <div>
              <Label>Reply-To Email</Label>
              <Input placeholder="support@propfirmhouse.com" className="mt-2" />
            </div>
          </div>
        </div>
        
        <div className="pt-4 border-t">
          <h3 className="font-semibold text-slate-900 mb-3">Email Types</h3>
          <div className="space-y-3">
            <div className="flex items-center justify-between p-3 bg-slate-50 rounded-lg">
              <div>
                <p className="text-sm font-medium text-slate-900">Transactional Emails</p>
                <p className="text-xs text-slate-500">Welcome, password reset, notifications</p>
              </div>
              <Switch defaultChecked />
            </div>
            <div className="flex items-center justify-between p-3 bg-slate-50 rounded-lg">
              <div>
                <p className="text-sm font-medium text-slate-900">Marketing Emails</p>
                <p className="text-xs text-slate-500">Newsletters, promotional content</p>
              </div>
              <Switch defaultChecked />
            </div>
            <div className="flex items-center justify-between p-3 bg-slate-50 rounded-lg">
              <div>
                <p className="text-sm font-medium text-slate-900">Review Notifications</p>
                <p className="text-xs text-slate-500">New review alerts for admins</p>
              </div>
              <Switch defaultChecked />
            </div>
          </div>
        </div>
        
        <div className="flex gap-2">
          <Button onClick={() => toast.success('Email settings saved')}>
            <Save className="h-4 w-4 mr-2" />
            Save Changes
          </Button>
          <Button variant="outline" onClick={() => toast.info('Test email sent!')}>
            Send Test Email
          </Button>
        </div>
      </CardContent>
    </Card>
  );
};